import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type BaseLayoutProps = {
  children: ReactNode;
  className?: string;
};

type PageHeaderProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
};

export function MainContent({ children, className }: BaseLayoutProps) {
  return (
    <section className={cn("flex-1 overflow-y-auto", className)}>
      {children}
    </section>
  );
}

export function PageContainer({ children, className }: BaseLayoutProps) {
  return (
    <div className={cn("mx-auto flex w-full max-w-300 flex-col gap-6 px-4 py-6 md:px-6 md:py-8", className)}>
      {children}
    </div>
  );
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <header className={cn("flex flex-col gap-4 md:flex-row md:items-start md:justify-between", className)}>
      <div className="space-y-1">
        <h1 className="font-display text-4xl font-semibold tracking-tight">{title}</h1>
        {description ? <p className="text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex justify-center h-full items-center gap-2">{actions}</div> : null}
    </header>
  );
}

export function PageSection({ children, className }: BaseLayoutProps) {
  return <section className={cn("space-y-4", className)}>{children}</section>;
}
